import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommonResponse} from '../interfaces/home';

@Injectable({
  providedIn: 'root'
})
export class ServiceTaskDeliverableService {

  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl+'ServiceTaskDeliverable/';
  // fetch all ServiceTaskDeliverable in the database
  allData(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  getServiceTaskDeliverable(id: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl +id);
  }
  getServiceTaskDeliverableByName(name: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl + 'name/' + name);
  }
  postServiceTaskDeliverable(data: any){
    return this.http.post(this.baseUrl, data);
  }
  deleteServiceTaskDeliverable(id: any){
    return this.http.delete(this.baseUrl +id);
  }
  updateServiceTaskDeliverable(id: any, data: any){
    return this.http.put(this.baseUrl +id, data);
  }
}
